import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { BehaviorSubject } from 'rxjs';
import { NToggle } from '@df/ui/toggle/toggle.service';

@Component({
    standalone: false,
    selector: 'icms-hide-up, [iCmshideUp]',
    templateUrl: 'icms-hide-up.html',
    styleUrls: ['icms-hide-up.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsHideUpComponent extends HideUpComponent {
    @Input()
    set iCmshideUp(value: BehaviorSubject<boolean> | NToggle.TGroupId | NToggle.TId | boolean) {
        this.hideUp = value;
    }
}
